import React, {useEffect, useState} from 'react';
import {
    Paper, Table,
    TableBody, TableCell, TableContainer, TablePagination, TableRow, LinearProgress

} from '@material-ui/core';

import {coreStyle, EnhancedTableHead} from "../../styles/config";
import Edit from "./add";
import DeleteButton from "../../utils/delete";
import {parseQueryParams} from "../../utils/helpers";
import Resource from "../../crud/resource";
import Search from "../../widgets/Search";
import {useSelector} from "react-redux";
import {startCase} from "lodash";
import Translate from "../../utils/utils";

const headCells = [
    {id: 'name', label: <Translate id={"TABLE.NAME"}/>},
    {id: 'date', label: <Translate id={"TABLE.DATE"}/>},
    {id: 'actions', label: <Translate id={"TABLE.ACTIONS"}/>},
];

export default function DeliveryLocationList(props) {
    const {location: {search}, history} = props;
    const queryParams = parseQueryParams(search);
    const [page, setPage] = React.useState(queryParams.page);
    const perPage = queryParams.perPage;;
    const [deliveryLocations, setDeliveryLocations] = useState([]);
    const initialValues = {name: ""};
    const [deliveryLocation, setDeliveryLocation] = useState(initialValues);
    const [name, setName] = useState(queryParams.name);
    const [isLoading, setIsLoading] = useState(false);
    const moduleName = 'deliveryLocation';
    const resource = new Resource(moduleName);

    const [pagination, setPagination] = useState({
        total: 0,
        current_page: 1,
        per_page: queryParams.perPage,
    });
    const user = useSelector(store => store.auth.user);

    const removeItemInListing = (id) => {
        const remaining = deliveryLocations.filter((item) => item.id !== id);
        const total = remaining.length;
        setPagination(Object.assign(pagination, {total: pagination.total - 1, 'to': total}));
        setDeliveryLocations(remaining);
    };

    useEffect(() => {

        const list = () => {
            setIsLoading(true);
            const resource = new Resource(moduleName);
            resource.index({
                perPage,
                page,
                name
            })
                .then(response => {
                    const {data: {data = {data: []}}} = response;
                    const paginationData = data;
                    setDeliveryLocations(paginationData.data);
                    setPagination(paginationData);
                    setIsLoading(false);
                }).catch(err => {
                setIsLoading(false);
            });
        };
        list();
    }, [page, perPage, moduleName]);


    const handleChangePage = (e, page) => {
        setPage(++page);
        return history.push(`?page=${page}&perPage=${perPage}&name=${name}`);
    };

    const handlePerPageChange = (perPage) => {
        history.push(`?page=1&perPage=${perPage}&name=${name}`);
    };

    const handleCreate = (deliveryLocation) => {
        const deliveryLocationsList = [deliveryLocation, ...deliveryLocations];
        setDeliveryLocations(deliveryLocationsList);
    };

    const handleUpdate = (deliveryLocation) => {
        const deliveryLocationList = deliveryLocations.map(item => {
            if (item.id === deliveryLocation.id) {
                return deliveryLocation;
            }
            return item;
        });
        setDeliveryLocations(deliveryLocationList);
    };

    const onType = (e) => {
        const {target: {value}} = e;
        setName(value);
    };

    const onClearSearch = () => {
        history.push(`?page=1&perPage=${perPage}`);
    };

    const onSearch = () => {
        history.push(`?page=1&perPage=${perPage}&name=${name}`);
    };

    return (
        <div className={coreStyle.root}>
            <div className="add-user__button">
                <Edit handleCreate={handleCreate} resource={resource} initialValues={deliveryLocation}
                      key={deliveryLocation.id}
                      handleUpdate={handleUpdate} onCloseModal={() => setDeliveryLocation(initialValues)}
                      moduleName={startCase(moduleName)}
                />
            </div>

            <Search onType={onType} onSubmit={onSearch} module={startCase(moduleName)} onClear={onClearSearch}
                    disabled={isLoading} value={queryParams.name}/>

            {isLoading && <LinearProgress color="secondary"/>}
            <Paper className={coreStyle.paper}>
                <TableContainer>
                    <Table
                        className={coreStyle.table}
                        aria-labelledby="tableTitle"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            rowCount={deliveryLocations.length}
                            headCells={headCells}
                            isLoading={isLoading}
                        />
                        <TableBody>
                            {deliveryLocations.map(deliveryLocation => {

                                return (
                                    <TableRow
                                        hover
                                        tabIndex={-1}
                                        key={deliveryLocation.id}
                                    >
                                        <TableCell component="th" scope="row">
                                            {deliveryLocation.name}
                                        </TableCell>
                                        <TableCell>{deliveryLocation.created_at}</TableCell>
                                        <TableCell>
                                            <button className='button-edit-delete'
                                                    onClick={() => {
                                                        setDeliveryLocation(deliveryLocation)
                                                    }}>{<Translate id={"TABLE.ACTIONS.EDIT"}/>}
                                            </button>

                                            {user.role.name !== 'INSPECTOR' &&
                                            <>
                                                <em className='actions-separator'>|</em>
                                                <DeleteButton
                                                    module={moduleName}
                                                    itemId={deliveryLocation.id}
                                                    itemName={deliveryLocation.name}
                                                    removeItemInListing={removeItemInListing}
                                                />
                                            </>
                                            }

                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[15, 50, 100]} labelRowsPerPage={<Translate id="TABLE.ROWS_PER_PAGE"/>}
                    component="div"
                    count={pagination.total}
                    rowsPerPage={pagination.per_page}
                    page={pagination.current_page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={(e) => handlePerPageChange(e.target.value)}
                />
            </Paper>
        </div>
    );
}
